import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function SiteLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="flex min-h-screen flex-col bg-[#07090E]">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export const PageHeader = ({ eyebrow, title, children, testId }) => (
  <section className="relative overflow-hidden border-b border-white/5">
    <div className="bg-grid grid-fade absolute inset-0" />
    <div className="glow-orb absolute -top-32 left-1/4 h-80 w-80" />
    <div className="relative mx-auto max-w-7xl px-4 pb-16 pt-20 sm:px-6 md:pb-20 md:pt-28 lg:px-12">
      <p className="rise mb-5 font-mono-tech text-xs uppercase tracking-[0.25em] text-cyan-400">{eyebrow}</p>
      <h1 data-testid={testId} className="rise max-w-3xl text-4xl font-extrabold leading-[1.1] tracking-tight text-white sm:text-5xl lg:text-6xl" style={{ animationDelay: "80ms" }}>
        {title}
      </h1>
      {children && (
        <p className="rise mt-6 max-w-2xl text-base leading-relaxed text-slate-400 md:text-lg" style={{ animationDelay: "160ms" }}>
          {children}
        </p>
      )}
    </div>
  </section>
);

export const CtaBanner = () => (
  <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 md:py-24 lg:px-12">
    <div className="noise relative overflow-hidden rounded-2xl border border-cyan-400/20 bg-[#0B111D] p-8 sm:p-12">
      <div className="glow-orb absolute -right-20 -top-20 h-72 w-72" />
      <div className="relative flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
        <div className="max-w-xl">
          <p className="mb-3 font-mono-tech text-xs uppercase tracking-widest text-cyan-400">// next_project</p>
          <h2 className="text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">Have a site to build, fix or scale?</h2>
          <p className="mt-4 text-slate-400">Tell us what you're working on. You'll get a clear plan, a fixed quote and a real timeline.</p>
        </div>
        <a href="/contact" data-testid="cta-banner-contact-button"
          className="btn-glow inline-flex shrink-0 items-center justify-center rounded-full bg-cyan-400 px-7 py-3.5 text-sm font-semibold text-[#07090E] hover:bg-cyan-300">
          Start a project
        </a>
      </div>
    </div>
  </section>
);
